import type { IconName } from "@/components/icons/Icon";
import type { DocumentModel } from "@/models/DocumentModel";

export function useInlineTextStyleIcon(doc: DocumentModel): {
  textStyleIcon: IconName;
  isActive: boolean;
} {
  const { isBold, isItalic, isUnderline, isStrikethrough } = doc.editor.editorState;

  const activeMarks = [
    isBold && "bold",
    isItalic && "italic",
    isStrikethrough && "strike",
    isUnderline && "underline",
  ].filter((mark): mark is string => !!mark);

  const isActive = activeMarks.length > 0;
  const combo = activeMarks.join("-");
  const name = combo.charAt(0).toUpperCase() + combo.slice(1);

  return {
    textStyleIcon: (isActive ? `text-style/${name}` : "text-style/Bold") as IconName,
    isActive,
  };
}
